<div
	*ngIf="editMode && !isAddMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30 lg:p-24px"
></div>
<div class="mb-[24px]" [formGroup]="offerForm">
	<!-- Activation State Start -->

	<div class="w-full h-[98px] rounded-[12px] bg-main-color-black">
		<div
			class="flex justify-between px-[24px] py-[28px] max-mobile:px-padding-mobile-14 max-mobile:py-padding-mobile-14"
		>
			<div class="flex flex-col my-auto max-mobile:text-font-mobile-small">
				<p class="text-gradient mb-1">
					{{ 'OFFERS.STATUS' | translate }}
				</p>
				<p class="text-[#F5F5F5] mb-1 max-mobile:text-font-mobile-small">
					{{ 'OFFERS.ABILITY_TO' | translate }}
				</p>
			</div>

			<div class="flex" *ngIf="!isAddMode && !offerData?.hasEnded">
				<ng-container *ngFor="let val of isActiveEnum">
					<span
						*ngIf="offerData?.isActive == val?.value"
						class="{{
							offerData?.isActive ? ' text-[#00BA88] ' : '  text-[#B3261E]  '
						}}mx-auto lg:mt-3 mt-5 max-mobile:text-font-mobile-small max-mobile:mt-[21px]"
						>{{ 'STATUS.' + val.name.toUpperCase() | translate }}</span
					>
				</ng-container>
				<div class="lg:w-[36px] m-auto mx-2">
					<mat-slide-toggle
						(change)="updateStatus($event)"
						[checked]="offerData?.isActive"
						hideIcon
					></mat-slide-toggle>
				</div>
			</div>
			<div class="flex" *ngIf="isAddMode">
				<ng-container *ngFor="let val of isActiveEnum">
					<span
						*ngIf="getController('isActive')?.value == val?.value"
						class="{{
							getController('isActive')?.value
								? ' text-[#00BA88] '
								: '  text-[#B3261E]  '
						}}mx-auto lg:mt-3 mt-5"
						>{{ 'STATUS.' + val.name.toUpperCase() | translate }}</span
					>
				</ng-container>
				<div class="lg:w-[36px] m-auto mx-2">
					<mat-slide-toggle
						formControlName="isActive"
						[checked]="offerData?.isActive"
						hideIcon
					></mat-slide-toggle>
				</div>
			</div>
		</div>
	</div>

	<!-- Activation State End -->
	<div>
		<!-- Basic Data Section Start -->

		<div
			class="flex flex-row px-24px justify-between mt-[24px] py-2 min-h-[40px]"
		>
			<p
				class="text-[#1C252E] font-medium text-lg leading-5 max-mobile:text-font-mobile-medium"
			>
				{{ 'OFFERS.BASIC_INFO' | translate }}
			</p>

			<div
				(click)="changeEditMode()"
				*ngIf="!editMode && !isAddMode && !offerData?.hasEnded"
				class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
			>
				<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
				<p class="text-[#009EF7]">{{ 'ACTIONS.EDIT' | translate }}</p>
			</div>
		</div>
		<div
			class="flex flex-col custom-shadow p-24px gap-[14px] rounded-12px bg-off-white  {{
				editMode && !isAddMode ? 'z-40' : ''
			}} relative  "
		>
			<div>
				<div formGroupName="name">
					<!-- offer en name -->
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey"
							>{{ 'OFFERS.NAME_EN' | translate }}
						</mat-label>
						<input
							formControlName="en"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{ 'OFFERS.NAME_EN' | translate }}"
						/>
						<img
							*ngIf="
								getController('name').get('en')?.value &&
								(editMode || isAddMode)
							"
							(click)="getController('name').get('en')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('name').get('en')"
								controller_name="OFFERS.NAME_EN"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.NAME_EN' | translate }}
						</p>
						<p class="viewMode">{{ offerData?.name?.en }}</p>
					</div>
					<!-- offer ar name -->

					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.NAME_AR' | translate
						}}</mat-label>
						<input
							required
							formControlName="ar"
							class="text-font-16 text-[#4E4B66] w-[96%]"
							type="text"
							matInput
							maxlength="150"
							placeholder="{{ 'OFFERS.NAME_AR' | translate }}"
						/>
						<img
							*ngIf="
								getController('name').get('ar')?.value &&
								(editMode || isAddMode)
							"
							(click)="getController('name').get('ar')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('name').get('ar')"
								controller_name="OFFERS.NAME_AR"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>

					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.NAME_AR' | translate }}
						</p>
						<p class="viewMode">{{ offerData?.name?.ar }}</p>
					</div>
				</div>
				<!-- promo code  name -->

				<mat-form-field
					*ngIf="editMode || isAddMode"
					class="w-full relative"
					appearance="outline"
				>
					<mat-label class="text-dark-grey">{{
						'OFFERS.PROMO_CODE' | translate
					}}</mat-label>
					<input
						required="true"
						formControlName="code"
						type="text"
						class="text-font-16 text-[#4E4B66]"
						placeholder="{{ 'OFFERS.PROMO_CODE' | translate }}"
						matInput
						maxlength="20"
					/>
					<img
						*ngIf="getController('code')?.value && (editMode || isAddMode)"
						(click)="getController('code')?.reset()"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
					/>
					<mat-error>
						<validation-message
							[controller]="getController('code')"
							controller_name="OFFERS.PROMO_CODE"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<div
					*ngIf="!editMode && !isAddMode"
					class="w-full max-h-[73px] pt-[17px] m-0 p-0"
				>
					<p class="mb-0 pb-0 text-[#6E7191]">
						{{ 'OFFERS.PROMO_CODE' | translate }}
					</p>
					<p class="viewMode mb-0 pb-0">{{ offerData?.code }}</p>
				</div>

				<!-- <P *ngIf="editMode" class="pb-[12px] pt-[5px] text-[#4E4B66]">
					{{ 'SERVICE.HINT' | translate }}</P
				> -->

				<!-- imgss -->
				<div
					*ngIf="editMode || isAddMode"
					class="mt-[18px] bg-light-grey rounded-12px p-24px mb-5"
				>
					<!-- IMG HINT -->
					<p
						class="text-font-16 ltr:font-DIN-bold font-bold rtl:font-semibold text-dark-grey mb-[4px]"
					>
						{{ 'OFFERS.REFRENCE_IMG' | translate }}
					</p>
					<p class="text-font-14 text-dark-grey mb-[28px]">
						{{ 'OFFERS.CAUTION_HINT_MESSAGE' | translate }}
					</p>
					<div>
						<div
							class="inline-block max-mobile:m-0 lg:ltr:mr-[70px] rtl:ml-[70px] relative"
						>
							<img src="./assets/images/promo_code_img.svg" alt="" />
							<button
								class="bg-gradient px-[20px] max-mobile:px-[10px] max-smMobile:px-[5px] max-smMobile:py-[2px] py-[4px] max-mobile:py-[2px] text-off-white rounded-[5px] absolute bottom-[15px] max-mobile:bottom-[5px] left-[10px] max-mobile:left-[3px] max-mobile:text-[8px] max-smMobile:text-[7px]"
							>
								{{ 'OFFERS.COPY_PROMOCODE' | translate }}
							</button>
						</div>
						<div
							class="hidden max-mobile:inline-block max-mobile:mr-0 mr-[10px] w-[49%] max-mobile:w-full"
						>
							<p class="inline-block text-font-12">
								<span
									><img
										class="inline-block"
										src="./assets/images/information.svg"
										alt=""
								/></span>
								{{ 'OFFERS.CASE_ALL_SALONS' | translate }}
							</p>
						</div>
						<div class="inline-block relative">
							<img src="./assets/images/promo_code_img.svg" alt="" />
							<button
								class="bg-gradient px-[20px] max-mobile:px-[10px] max-smMobile:px-[5px] max-smMobile:py-[2px] py-[4px] max-mobile:py-[2px] text-off-white rounded-[5px] absolute bottom-[15px] max-mobile:bottom-[5px] left-[10px] max-mobile:left-[3px] max-mobile:text-[8px] max-smMobile:text-[5px]"
							>
								{{ 'OFFERS.COPY&VIEW' | translate }}
							</button>
						</div>
					</div>

					<div class="inline-block">
						<img src="./assets/images/promo_code_img2.svg" alt="" />
					</div>
					<div class="mb-12px">
						<div
							class="inline-block max-mobile:hidden mr-[10px] w-[49%] max-mobile:w-full"
						>
							<div class="flex">
								<img
									class="inline-block mx-[6px] h-full"
									src="./assets/images/information.svg"
									alt=""
								/>
								<p class="inline-block text-font-16">
									{{ 'OFFERS.CASE_ALL_SALONS' | translate }}
								</p>
							</div>
						</div>
						<div class="inline-block w-[49%] max-mobile:w-full">
							<div class="flex">
								<img
									class="inline-block mx-[6px] h-full"
									src="./assets/images/information.svg"
									alt=""
								/>
								<p class="inline-block text-font-16 mb-0">
									{{ 'OFFERS.CASE_SPECIFIC_SALONS' | translate }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="editMode || isAddMode">
					<!-- IMG HINT -->
					<div
						class="flex flex-wrap lg:justify-between w-full gap-5 mb-2 relative"
					>
						<div
							class=" min-h-[149px] md:w-[48%] w-full {{
								getController('image')?.get('ar')?.value ? '' : 'border-dashed'
							}} {{
								getController('image')?.get('ar')?.value ? '' : 'border'
							}} rounded-[6px] border-[#D9DBE9]   flex justify-center items-center relative"
						>
							<p
								*ngIf="!getController('image')?.get('ar')?.value"
								class="text-gradient absolute top-4 ltr:left-[40%] rtl:right-[40%] text-[16px]"
							>
								*
							</p>
							<button
								(click)="uploadImage('ar')"
								[disabled]="isAppointmentsCount"
							>
								<label class="custom-file-upload cursor-pointer">
									<img
										class="m-auto rounded-[6px] {{
											getController('image')?.get('ar')?.value ? 'w-full' : ''
										}}"
										[src]="
											getController('image')?.get('ar')?.value
												? attachmentUrl +
												  getController('image')?.get('ar')?.value
												: './assets/images/upload.svg'
										"
										alt=""
									/>

									<h1
										*ngIf="!getController('image')?.get('ar')?.value"
										class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
									>
										{{ 'ACTIONS.UPLOAD_IMG_AR' | translate }}
									</h1>
								</label>
							</button>
							<button
								class="absolute bottom-3 ltr:right-3 rtl:left-3"
								*ngIf="!isAppointmentsCount"
								(click)="
									$event.stopPropagation();
									getController('image')?.get('ar')?.reset()
								"
							>
								<img
									*ngIf="getController('image')?.get('ar')?.value"
									class="bg-white rounded-full p-2 w-9"
									src="assets/images/delete.svg"
									alt=""
								/>
							</button>
						</div>
						<div
							class=" min-h-[149px] md:w-[48%] w-full {{
								getController('image')?.get('en')?.value ? '' : 'border-dashed'
							}} {{
								getController('image')?.get('en')?.value ? '' : 'border'
							}} rounded-[6px] border-[#D9DBE9]   flex justify-center items-center relative"
						>
							<p
								*ngIf="!getController('image')?.get('en')?.value"
								class="text-gradient absolute top-4 ltr:left-[40%] rtl:right-[40%] text-[16px]"
							>
								*
							</p>
							<button
								(click)="uploadImage('en')"
								[disabled]="isAppointmentsCount"
							>
								<label class="custom-file-upload cursor-pointer">
									<img
										class="m-auto rounded-[6px] {{
											getController('image')?.get('en')?.value ? 'w-full' : ''
										}} "
										[src]="
											getController('image')?.get('en')?.value
												? attachmentUrl +
												  getController('image')?.get('en')?.value
												: './assets/images/upload.svg'
										"
										alt=""
									/>

									<h1
										*ngIf="!getController('image')?.get('en')?.value"
										class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
									>
										{{ 'ACTIONS.UPLOAD_IMG_EN' | translate }}
									</h1>
								</label>
							</button>
							<button
								class="absolute bottom-3 ltr:right-3 rtl:left-3"
								*ngIf="!isAppointmentsCount"
								(click)="
									$event.stopPropagation();
									getController('image')?.get('en')?.reset()
								"
							>
								<img
									*ngIf="getController('image')?.get('en')?.value"
									class="bg-white rounded-full p-2 w-9"
									src="assets/images/delete.svg"
									alt=""
								/>
							</button>
						</div>
					</div>
				</div>
				<div>
					<div
						*ngIf="!editMode && !isAddMode"
						class="flex mt-[18px] flex-wrap lg:justify-between gap-2 rounded-[14px] w-full"
					>
						<img
							[src]="attachmentUrl + offerData?.image?.ar"
							class="h-[149px] md:w-[48%] sm:w-[100%] mb-2 rounded-[14px]"
							alt=""
							onerror="this.src='assets/images/empty state.jpg'"
						/>
						<img
							[src]="attachmentUrl + offerData?.image?.en"
							class="h-[149px] md:w-[48%] sm:w-[100%] rounded-[14px]"
							alt=""
							onerror="this.src='assets/images/empty state.jpg'"
						/>
					</div>
					<!-- duration -->
					<div>
						<p
							*ngIf="editMode || isAddMode"
							class="text-font-12 text-dark-grey"
						>
							{{ 'OFFERS.DURATION' | translate }}
							<span class="text-[#7e2eb3]">*</span>
						</p>
						<div
							class="flex flex-wrap md:justify-between w-full py-2"
							*ngIf="editMode || isAddMode"
						>
							<mat-form-field
								appearance="outline"
								class="md:w-[47%] w-[100%]"
								(click)="datepicker.open()"
							>
								<input
									[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
									matInput
									[min]="today"
									[matDatepicker]="datepicker"
									formControlName="startDate"
									class="text-[#4E4B66]"
								/>
								<img
									*ngIf="
										getController('startDate')?.value && (editMode || isAddMode)
									"
									(click)="getController('startDate').reset()"
									class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
									src="./assets/images/close-square.svg"
									alt=""
								/>
								<mat-datepicker #datepicker> </mat-datepicker>
								<mat-error>
									<validation-message
										[controller]="getController('startDate')"
										controller_name="GENERAL_LABELS.START_DATE"
									>
									</validation-message>
								</mat-error>
							</mat-form-field>

							<p
								class="text-[#4E4B66] text-center md:mt-5 mx-auto w-[3%] max-mobile:w-[100%]"
							>
								{{ 'GENERAL.TO' | translate }}
							</p>
							<mat-form-field
								appearance="outline"
								class="md:w-[47%] w-[100%]"
								(click)="datepickerTo.open()"
							>
								<input
									[dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'"
									matInput
									[min]="today"
									[matDatepicker]="datepickerTo"
									formControlName="endDate"
									class="text-[#4E4B66]"
								/>
								<img
									*ngIf="
										getController('endDate')?.value && (editMode || isAddMode)
									"
									(click)="getController('endDate').reset()"
									class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
									src="./assets/images/close-square.svg"
									alt=""
								/>
								<mat-datepicker #datepickerTo> </mat-datepicker>
								<mat-error>
									<validation-message
										[controller]="getController('endDate')"
										controller_name="GENERAL_LABELS.END_DATE"
									>
									</validation-message>
								</mat-error>
							</mat-form-field>
						</div>

						<mat-error class="mb-[12px]">
							<div
								class="whitespace-nowrap"
								*ngIf="
									getController('endDate').value <
										getController('startDate').value &&
									getController('endDate').value
								"
							>
								{{ 'VALIDATION.END_DATE_ERROR' | translate }}
							</div>
						</mat-error>
					</div>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.DURATION' | translate }}
						</p>
						<div class="flex">
							<p class="viewMode max-mobile:text-font-mobile-small">
								{{ offerData?.startDate | date : 'dd / MM / yyy' }}
							</p>
							<p class="text-[#4E4B66] mx-4 max-mobile:mx-1">
								{{ 'GENERAL.TO' | translate }}
							</p>
							<p class="viewMode max-mobile:text-font-mobile-small">
								{{ offerData?.endDate | date : 'dd / MM / yyy' }}
							</p>
						</div>
					</div>
					<!-- max client usage -->
					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.MAX_CLIENT_USE' | translate
						}}</mat-label>
						<input
							(keypress)="skipLetterE($event)"
							required
							formControlName="maxNoOfClientUsage"
							class="text-font-16 text-[#4E4B66]"
							type="number"
							(wheel)="$event.preventDefault()"
							matInput
							[max]="+offerForm?.get('maxNoOfBookings')?.value"
							(keydown)="checkLength('maxNoOfClientUsage', $event, 2)"
							placeholder="{{ 'OFFERS.MAX_CLIENT_USE' | translate }}"
						/>
						<img
							*ngIf="
								getController('maxNoOfClientUsage')?.value &&
								(editMode || isAddMode)
							"
							(click)="getController('maxNoOfClientUsage')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('maxNoOfClientUsage')"
								controller_name="OFFERS.MAX_CLIENT_USE"
								pattern_Message="VALIDATION.NAME"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<p
						*ngIf="editMode || isAddMode"
						class="max-mobile:text-font-mobile-small"
					>
						{{ 'OFFERS.MAX_CLIENT_HINT' | translate }}
					</p>
					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0 border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.MAX_CLIENT_USE' | translate }}
						</p>
						<p class="viewMode">{{ offerData?.maxNoOfClientUsage }}</p>
					</div>
					<!-- MAX BOOKING USAGE -->

					<mat-form-field
						*ngIf="editMode || isAddMode"
						class="w-full relative"
						appearance="outline"
					>
						<mat-label class="text-dark-grey">{{
							'OFFERS.MAX_NO_BOOKINGS' | translate
						}}</mat-label>
						<input
							(keypress)="skipLetterE($event)"
							required
							formControlName="maxNoOfBookings"
							class="text-font-16 text-[#4E4B66]"
							type="number"
							(wheel)="$event.preventDefault()"
							matInput
							maxlength="2"
							placeholder="{{ 'OFFERS.MAX_NO_BOOKINGS' | translate }}"
							(keydown)="checkLength('maxNoOfBookings', $event, 2)"
						/>
						<img
							*ngIf="
								getController('maxNoOfBookings')?.value &&
								(editMode || isAddMode)
							"
							(click)="getController('maxNoOfBookings')?.reset()"
							class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getController('maxNoOfBookings')"
								controller_name="OFFERS.MAX_NO_BOOKINGS"
								pattern_Message="VALIDATION.NAME"
							>
							</validation-message>
							<p
								*ngIf="
									offerForm?.controls?.maxNoOfBookings?.errors
										?.bookingLessThanClient &&
									offerForm?.controls?.maxNoOfBookings?.value !== ''
								"
							>
								{{ 'OFFERS.MAX_CLIENT_USAGE' | translate }}
							</p>
						</mat-error>
					</mat-form-field>

					<div
						*ngIf="!editMode && !isAddMode"
						class="w-full max-h-[73px] pt-[17px] m-0 p-0"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'OFFERS.MAX_NO_BOOKINGS' | translate }}
						</p>
						<p class="viewMode">{{ offerData?.maxNoOfBookings }}</p>
					</div>
				</div>
				<!-- Action Buttons start -->
				<div class="flex justify-end" *ngIf="editMode && !isAddMode">
					<div
						class="flex"
						(click)="changeEditMode(); initForm(); isChanged = false"
					>
						<button
							class="border border-solid text-dark-grey border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
							mat-button
						>
							{{ 'ACTIONS.CANCEL' | translate }}
						</button>
						<!-- [disabled]="offerForm.invalid || !isChanged" -->
						<button
							[disabled]="offerForm.invalid"
							(click)="updateData()"
							class="bg-gradient text-off-white rounded"
							mat-button
						>
							{{ 'ACTIONS.SAVE' | translate }}
						</button>
					</div>
				</div>
				<!-- Action Buttons End -->
			</div>
			<!-- </div> -->
			<!-- </div> -->
		</div>
	</div>
</div>
